// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"0759cb41","453":"8ec72e35","623":"2105ea88","649":"6c034714","890":"26e22f9d","911":"0315880d","953":"d2b7ee92"}[chunkId] + ".chunk.js";
};